<template>
    <Link :href="route('admin.agencies.show', agency.uuid)" preserve-state class="block">
    <div class="py-2 px-2 my-2 border border-gray-200 flex justify-between items-center w-full hover:bg-gray-100">
        <div class="p-1">{{ agency.name }}</div>
        <div class="p-1">
            <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full mr-5" :class="[
                agency.deactivated === false
                    ? 'bg-lime-100 text-lime-800'
                    : 'bg-gray-100',
                'text-gray-800',
            ]">
                {{ t(agency.deactivated ? "agencies.inactive" : "agencies.active") }}
            </span>
            <PencilIcon class="h-5 w-5 float-right text-minplan-grey" aria-hidden="true" />
        </div>
    </div>
    </Link>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import { PencilIcon } from "@heroicons/vue/outline";
import { useI18n } from "vue-i18n";

export default {
    props: ["agency"],
    components: { Link, PencilIcon },
    setup() {
        const { t } = useI18n();
        return { t };
    },
};
</script>

<style scoped></style>
